import './academy.css';

import { useMemo, useState } from 'react';
import { useRecoilValue } from 'recoil';
import { teamsState } from '../../recoil/atoms/teamsState';
import { userConfigState } from '../../recoil/atoms/userConfigState';
import { navigationPropsState } from '../../recoil/atoms/navigationPropsState';
import { useSetNavigationProps } from '../../recoil/hooks/useSetNavigationProps';

import { StringToAnyMap } from '../../types/common';
import { LogisticTeamView } from '../../components/teamView/LogisticTeamView';
import { DynamicTabs } from '../../components/controls/navigation/DynamicTabs';
import { translate } from '../../../common/language/translations';
import { AcademyTableView } from './AcademyTableView';


export const Academy: React.FC = () => {

  const userConfig = useRecoilValue(userConfigState);
  const teams = useRecoilValue(teamsState);

  const [logisticTeamViewToggle, setLogisticTeamViewToggle] = useState(false);


  const academyTeams = useMemo(() => {
    if (!teams) return null;

    const academyTeams: StringToAnyMap = {
      'academyTable': {
        name: translate('allPlayers', userConfig?.language),
      },
    };

    Object.keys(teams)
      .filter(key => teams[key].isAcademyTeam)
      .forEach(key => {
        academyTeams[key] = teams[key];
      });

    return academyTeams;
  }, [teams, userConfig?.language]);


  const navigationProps = useRecoilValue(navigationPropsState);
  const activeSubTab = navigationProps?.activeAcademyTeamId && academyTeams?.[navigationProps.activeAcademyTeamId]
    ? navigationProps.activeAcademyTeamId
    : 'academyTable';

  const updateNavigationProps = useSetNavigationProps();
  const setActiveSubTabAndResetExpansions = (subTab: string | undefined) => {
    updateNavigationProps({ activeAcademyTeamId: subTab === 'academyTable' ? undefined : subTab }, true);
    setLogisticTeamViewToggle(!logisticTeamViewToggle);
  };


  return (
    <div className='platform-view-section'>

      <DynamicTabs
        teams={academyTeams}
        isAcademyTeams={true}
        activeTab={activeSubTab}
        setActiveTab={setActiveSubTabAndResetExpansions}
      />

      <div className='platform-view-content-container-with-tabs'>

        {activeSubTab === 'academyTable' && (
          <AcademyTableView />
        )}

        {activeSubTab !== 'academyTable' && (
          <LogisticTeamView
            teamId={activeSubTab}
            team={academyTeams && activeSubTab ? academyTeams[activeSubTab] : undefined}
            isTabLine={true}
            logisticTeamViewToggle={logisticTeamViewToggle}
          />
        )}

      </div>

    </div>
  );
};
